<template>
  <div id="Delivery">
    <div class="title">
      <img src="@/assets/images/dashboard/ic-ic-now-pig.svg" />
      <span>배민 매출 연결</span>
    </div>
    <div class="box">
      <component :is="currentComponent"></component>
    </div>
  </div>
</template>

<script>
import DeliveryService from '@/service/delivery/DeliveryService'

import DeliveryNotDefined from './DeliveryNotDefined'
import DeliveryPending from './DeliveryPending'
import DeliveryInProgress from './DeliveryInProgress'
import DeliveryCompleted from './DeliveryCompleted'

import { mapGetters } from 'vuex'

export default {
  name: 'Delivery',
  components: {
    DeliveryNotDefined,
    DeliveryPending,
    DeliveryInProgress,
    DeliveryCompleted,
  },
  async created() {
    DeliveryService.init()
    await DeliveryService.getDeliveryCredential()
  },
  computed: {
    ...mapGetters('delivery', {
      currentComponent: 'getCurrentComponent'
    })
  }
}
</script>

<style lang="scss">
#Delivery {
  display: block;
  float: left;
  margin-top: 20px;
  width: 100%;

  .title {
    height: 32px;

    img {
      float: left;
    }

    span {
      float: left;
      line-height: 25px;
      font-weight: 900;
      color: #333333;
      position: relative;
      top: 3px;
      margin-left: 7px;

      @media screen and (max-width: 350px) {
        font-size: 15px;
      }

      @media screen and (min-width: 350px) {
        font-size: 17px;
      }
    }
  }
  .box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: calc(21vh / 667 * 100);
    background: white;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.12);
    border-radius: 10px;
    margin-top: calc(13vh / 647 * 100);

    & > div {
      width: 100%;
      text-align: center;
    }

    .content {
      text-align: center;

      &.pending {
        &.unacceptable {
          margin-top: 10px;
          margin-bottom: 10px;
          font-weight: 700;
          margin-top: 10px;
          color: #333333;
        }
      }

      &.pending,
      &.in_progress {
        color: #1baaf1;
        font-weight: 900;
        font-size: 20px;
        margin-top: 10px;
      }

      &.in_progress {
        ~ h4 {
          margin-top: 5px;
          margin-bottom: 10px;
        }
      }

      &.completed {
        margin-top: 10px;
        margin-bottom: 10px;
        font-weight: 900;
      }
    }
    button {
      width: 100%;
      height: 44px;
      border-radius: 6px;
      background-color: #f2f9ff;
      font-weight: 700;
      font-size: 16px;
      letter-spacing: -0.23px;
      text-align: center;
      color: #1baaf1;
      margin-top: 14px;
      margin-bottom: 10px;

      b {
        font-weight: 900;
      }

      img {
        display: inline-block;
        float: none;
        vertical-align: middle;
      }
      span {
        display: inline-block;
        float: none;
        vertical-align: middle;
        margin-left: 11px;
      }
    }
  }
}
</style>
